module.exports = __webpack_public_path__ + "img/linfield.d61bc52d.png";